<div class="app-product-shopping-cart" id="shipping-product" [ngClass]="{'merchandise-padding': isMerchandiseFlow()}" 
[ngStyle]="{'background-color':settingsData?.merchandise_bg_main_color,'color':settingsData?.merchandise_font_main_color}">
    <div *ngIf="isMobPaymentSuccess" class="p-30" fxLayout="column">
        <div fxFlex="100%" fxLayoutAlign="center center" class="text-center" [ngStyle]="{'color':settingsData?.merchandise_font_primary_color}">
            Payment completed Successfully. Go to the application.
        </div>
        <div class="text-center mt-20" fxFlex="100%" fxLayoutAlign="center center">
            <button class="flat-primary-button p-10" [ngStyle]="{'background-color':settingsData?.merchandise_button_bg_primary_color,'color':settingsData?.merchandise_button_font_primary_color}" target="_other" rel="nofollow" (click)="goToMarketPlace()">
                Go To MarketPlace
            </button>
        </div>
    </div>
    <div *ngIf="showOverlay" class="p-msg">
        <span class="p-msg-disp text-center" [ngStyle]="{'color':settingsData?.merchandise_font_main_color}">Please do not refresh the page while we are
            processing your payment
            {{timer}}</span>
    </div>
    <div class="pl-20 pr-30" *ngIf="!isMobPaymentSuccess">
        <div class="pl-15 pointer" (click)="redirectTo()" *ngIf="deviceInfo == 'web'">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
            <span class="fs-16 ml-10">Back</span>
        </div>
        <div class="pl-15 pointer" *ngIf="deviceInfo != 'web'">
            <a [href]="redirectMobileURL" class="anchor-class" [ngStyle]="{'color':settingsData?.merchandise_font_main_color}">
                <i class="fa fa-arrow-left" aria-hidden="true"></i>
                <span class="fs-16 ml-10">Back</span>
            </a>
        </div>
        <!-- <div>
            <div class="product-heading">Shipping Address </div>
        </div> -->
        <div class="row">

            <div class="col-lg-7 col-sm-12 col-md-12 col-xs-12">
                <div fxLayout="column">
                    <div fxFlex="50%" class="ptb-10 pl-15" *ngIf="digitalProducts?.length > 0">
                        <mat-form-field class="w-32">
                            <mat-label><span>Email</span></mat-label>
                            <input matInput placeholder="" [(ngModel)]="email" required
                                (blur)="proceedWithAddress()">
                        </mat-form-field>
                    </div>
                    <div class="radio-btn" [style.--ship-radio-color]="addressRadioColor">
                        <ng-container>
                            <div *ngIf="userInfo?.id">
                                <app-default-address [currentBlock]="currentBlock" [settingsData]="settingsData" [organizationId]="organizationId"></app-default-address>
                            </div>
                        </ng-container>
                    </div>
                    <div fxLayout="column" class="pl-15" *ngIf="showShippingForm && newShippingForm">
                        <div fxFlex="100%">
                            <h6 class="sub-heading pt-15">Shipping Address</h6>
                        </div>
                        <form class="display-block plr-25 pt-10 pb-15 mb-10" [ngStyle]="{'background-color':settingsData?.merchandise_bg_primary_color,'color':settingsData?.merchandise_font_primary_color}" [formGroup]="shippingForm">
                            <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="15px grid">
                                <div fxFlex="33.3%" fxFlex.xs="100%">
                                    <mat-form-field class="w-100">
                                        <mat-label><span>Country</span></mat-label>
                                        <input matInput placeholder="" name="Country" [matAutocomplete]="auto"
                                            (input)="filterCountry('getShippingValue')" formControlName="country"
                                            required>
                                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCountryName"
                                            (optionSelected)="selectCountry($event.option,'shippingForm');">
                                            <mat-option *ngFor="let country of shippingCountries;"
                                                [value]="country">
                                                <span>{{country.name}}</span>
                                            </mat-option>
                                        </mat-autocomplete>
                                        <mat-error *ngIf="shippingForm.get('country').hasError('required')">
                                            Please select country
                                        </mat-error>
                                        <mat-error *ngIf="!shippingForm.get('country').hasError('required') &&
                                shippingForm.get('country').hasError('mat-require-match')">
                                            Please select country from existing list
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33.3%" fxFlex.xs="100%">
                                    <mat-form-field class="w-100 relative" *ngIf="countryChanged">
                                        <mat-label>
                                            <span *ngIf="shippingCountry.name != 'United Kingdom'">Address line
                                                1</span>
                                            <span *ngIf="shippingCountry.name == 'United Kingdom'">Address</span>
                                        </mat-label>
                                        <input matInput placeholder="" formControlName="address1"
                                            ngx-gp-autocomplete [options]="options"
                                            (blur)="proceedWithAddress()"
                                            (onAddressChange)="getSelectedAddress($event,'shippingForm')"
                                            (paste)="onPasteLocation($event,'shippingForm')" required />
                                        <mat-error *ngIf="shippingForm.get('address1').hasError('required')">
                                            Please enter address
                                        </mat-error>
                                    </mat-form-field>
                                    <!-- <span class="fs-11">Note: Please select your address from auto populated list</span> -->
                                </div>
                                <div fxFlex="33.3%" fxFlex.xs="100%" *ngIf="shippingCountry.name != 'United Kingdom'">
                                    <mat-form-field class="w-100">
                                        <mat-label><span>Address line 2</span></mat-label>
                                        <input matInput placeholder="" autocomplete="disabled"
                                            formControlName="address2">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33.3%" fxFlex.xs="100%">
                                    <mat-form-field class="w-100">
                                        <mat-label><span>City</span></mat-label>
                                        <input matInput placeholder="" (blur)="proceedWithAddress()"
                                            formControlName="city" required>
                                        <mat-error *ngIf="shippingForm.get('city').hasError('required')">
                                            Please enter city
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33.3%" fxFlex.xs="100%" *ngIf="shippingCountry.stateless != 'yes'">
                                    <mat-form-field class="w-100">
                                        <mat-label><span>State</span></mat-label>
                                        <input matInput placeholder="" (blur)="proceedWithAddress()"
                                            formControlName="state" required>
                                        <mat-error *ngIf="shippingForm.get('state').hasError('required')">
                                            Please enter state
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33.3%" fxFlex.xs="100%">
                                    <mat-form-field class="w-100" *ngIf="shippingCountry.name != 'United Kingdom'">
                                        <mat-label><span>Zip code</span></mat-label>
                                        <input matInput placeholder="" (blur)="proceedWithAddress()"
                                            formControlName="zip" required>
                                        <mat-error *ngIf="shippingForm.get('zip').hasError('required')">
                                            <span>Please enter zip code</span>
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field class="w-100" *ngIf="shippingCountry.name == 'United Kingdom'">
                                        <mat-label><span>Postal code</span></mat-label>
                                        <input matInput placeholder="" (blur)="proceedWithAddress()"
                                            formControlName="zip" required>
                                        <mat-error *ngIf="shippingForm.get('zip').hasError('required')">
                                            <span>Please enter postal code</span>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33.3%" fxFlex.xs="100%" class="phone-number-placeholder">
                                    <span class="placeholder-label">Phone Number
                                        <span
                                            [ngClass]="{'placeholder-label-required' : (shippingForm.get('phone_number').hasError('required') && businessPhoneValue.touched) }">*</span>
                                    </span>
                                    <mat-form-field class="w-100 country-flag-txt">

                                        <input matInput countryFlagPhone allowValues isInputType="phone_number"
                                        formControlName="phone_number" required>
                                   <mat-error *ngIf="shippingForm.get('phone_number').hasError('required')">
                                       Please enter phone number
                                   </mat-error>
                                   <mat-error *ngIf="!shippingForm.get('phone_number').hasError('required') && 
                                   shippingForm.get('phone_number').hasError('isInvalid')">
                                       Please enter valid phone number
                                   </mat-error>

                                        <!-- <input matInput hidden="true" />
                                        <ngx-intl-tel-input [cssClass]="'custom'"
                                            [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="false"
                                            [enablePlaceholder]="true" [searchCountryFlag]="true"
                                            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                            [selectFirstCountry]="true" [selectedCountryISO]="selectedCountry"
                                            [maxLength]="15" [phoneValidation]="true"
                                            [separateDialCode]="separateDialCode" name="phone"
                                            formControlName="phone_number">
                                        </ngx-intl-tel-input>
                                        <mat-hint
                                            *ngIf="shippingForm.get('phone_number').hasError('required') && businessPhoneValue.touched">
                                            Please enter phone number
                                        </mat-hint>
                                        <mat-hint
                                            *ngIf="!shippingForm.get('phone_number').hasError('required') &&
                                            (businessPhoneValue.invalid || (businessPhoneValue.touched && businessPhoneValue.invalid))">
                                            Please enter valid phone number
                                        </mat-hint> -->
                                    </mat-form-field>
                                </div>
                            </div>
                        </form>
                    </div>
                    <ng-container *ngIf="showShippingForm && newShippingForm && showBillingForm">
                        <mat-checkbox name="addressval" class="fw-300 pl-15 pb-15 checkbox app-primary-bg  app-merchandise same-as-shipping"
                            [style.--checkbox-color]="sameAsShippingColors.box"
                            [style.--checkbox-label-color]="sameAsShippingColors.label"
                            [style.--checkbox-tick-color]="sameAsShippingColors.tick"
                            [ngClass]="{'slick-disabled':shippingForm.invalid}" [disabled]="shippingForm.invalid"
                            (change)="populateBillingAddress($event)">
                            Same as shipping address
                        </mat-checkbox>
                    </ng-container>
                    <div fxLayout="column" class="pl-15"
                        *ngIf="addressList?.billingAddress?.length == 0 || showBillingForm" (click)="saveQuestions()">
                        <div fxFlex="100%">
                            <h6 class="sub-heading mtb-10">Billing Address</h6>
                        </div>
                        <form class="display-block plr-25 pt-10 pb-15" [ngStyle]="{'background-color':settingsData?.merchandise_bg_primary_color,'color':settingsData?.merchandise_font_primary_color}" [formGroup]="billingForm">
                            <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="15px grid">
                                <div fxFlex="33.3%" fxFlex.xs="100%">
                                    <mat-form-field class="w-100">
                                        <mat-label><span>Country</span></mat-label>
                                        <input matInput placeholder="" name="Country" [matAutocomplete]="auto"
                                            (input)="filterCountry('getBillingValue')" formControlName="country"
                                            (blur)="setCountry($event)" required>
                                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCountryName"
                                            (optionSelected)="selectCountry($event.option,'billingForm');">
                                            <mat-option *ngFor="let country of countriesList;" [value]="country">
                                                <span>{{country.name}}</span>
                                            </mat-option>
                                        </mat-autocomplete>
                                        <mat-error *ngIf="billingForm.get('country').hasError('required')">
                                            Please select country
                                        </mat-error>
                                        <mat-error *ngIf="!billingForm.get('country').hasError('required') &&
                                billingForm.get('country').hasError('mat-require-match')">
                                            Please select country from existing list
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33.3%" fxFlex.xs="100%">
                                    <mat-form-field class="w-100" *ngIf="countryChanged">
                                        <mat-label>
                                            <span *ngIf="billingCountry.name != 'United Kingdom'">Address line
                                                1</span>
                                            <span *ngIf="billingCountry.name == 'United Kingdom'">Address</span>
                                        </mat-label>
                                        <input matInput placeholder="" formControlName="address1"
                                            ngx-gp-autocomplete [options]="options"
                                            (blur)="proceedWithAddress()"
                                            (onAddressChange)="getSelectedAddress($event,'billingForm')"
                                            (paste)="onPasteLocation($event,'billingForm')" required />
                                        <mat-error *ngIf="billingForm.get('address1').hasError('required')">
                                            Please enter address
                                        </mat-error>
                                    </mat-form-field>
                                    <!-- <span class="fs-11">Note: Please select your address from auto populated list</span> -->
                                </div>
                                <div fxFlex="33.3%" fxFlex.xs="100%" *ngIf="billingCountry.name != 'United Kingdom'">
                                    <mat-form-field class="w-100">
                                        <mat-label><span>Address line 2</span></mat-label>
                                        <input matInput placeholder="" (blur)="proceedWithAddress()"
                                            autocomplete="disabled" formControlName="address2">
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33.3%" fxFlex.xs="100%">
                                    <mat-form-field class="w-100">
                                        <mat-label><span>City</span></mat-label>
                                        <input matInput placeholder="" (blur)="proceedWithAddress()"
                                            formControlName="city" required>
                                        <mat-error *ngIf="billingForm.get('city').hasError('required')">
                                            Please enter city
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33.3%" fxFlex.xs="100%" *ngIf="billingCountry.stateless != 'yes'">
                                    <mat-form-field class="w-100">
                                        <mat-label><span>State</span></mat-label>
                                        <input matInput placeholder="" (blur)="proceedWithAddress()"
                                            formControlName="state" required>
                                        <mat-error *ngIf="billingForm.get('state').hasError('required')">
                                            Please enter state
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div fxFlex="33.3%" fxFlex.xs="100%">
                                    <mat-form-field class="w-100" *ngIf="billingCountry.name != 'United Kingdom'">
                                        <mat-label><span>Zip code</span></mat-label>
                                        <input matInput placeholder="" (blur)="proceedWithAddress()"
                                            formControlName="zip" required>
                                        <mat-error *ngIf="billingForm.get('zip').hasError('required')">
                                            <span>Please enter zip code</span>
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field class="w-100" *ngIf="billingCountry.name == 'United Kingdom'">
                                        <mat-label><span>Postal code</span></mat-label>
                                        <input matInput placeholder="" (blur)="proceedWithAddress()"
                                            formControlName="zip" required>
                                        <mat-error *ngIf="billingForm.get('zip').hasError('required')">
                                            <span>Please enter postal code</span>
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                            </div>
                        </form>
                    </div>
                    <div class="underline mt-2 mb-2 ml-15"></div>
                    <div class="col-lg-5 col-sm-12 col-md-12 col-xs-12" fxShow.xs = "true" fxHide>
                        <div class="couponBlock text-center p-3" [ngStyle]="{'background-color':settingsData?.merchandise_bg_secondary_color,'color':settingsData?.merchandise_font_secondary_color}">
                            <p class="blockHeading">Avail Coupons & Promotions
                            </p>
                            <input placeholder="Enter Code" class="formInput text-uppercase" [(ngModel)]="couponCode" [ngStyle]="{'background-color':settingsData?.merchandise_bg_secondary_color,'color':settingsData?.merchandise_font_main_color}">
                            <div class="mt-3">
                                <button mat-flat-button *ngIf="!isDiscountApplied" class="flat-primary-button" [ngStyle]="{'background-color':settingsData?.merchandise_button_bg_primary_color,'color':settingsData?.merchandise_button_font_primary_color}"
                                    (click)="verifyCoupon()">Apply</button>
                                <button mat-flat-button class="plain-white-btn" *ngIf="isDiscountApplied" [ngStyle]="{'background-color':settingsData?.merchandise_button_bg_secondary_color,'color':settingsData?.merchandise_button_font_secondary_color}"
                                    (click)="clearCode()">Clear</button>
                            </div>
                        </div>

                        <div class="couponBlock p-3 mt-3" [ngStyle]="{'background-color':settingsData?.merchandise_bg_secondary_color,'color':settingsData?.merchandise_font_secondary_color}">
                            <p class="blockHeading">ORDER SUMMARY</p>
                            <div class="underline mt-2"></div>
                            <div class="order-summary-block">
                                <div class="borderBoxCart mt-3 fs-12" [ngStyle]="{'background-color':settingsData?.merchandise_bg_primary_color,'color':settingsData?.merchandise_font_primary_color}"
                                    *ngFor="let prod of cartProductsList.slice(0 , !showAllProducts ? 2 :cartProductsList.length)">
                                <div class="d-flex">
                                    <div>
                                        <img appHideBrokenImg class="p-img" src="{{prod?.product_img}}">
                                    </div>
                                    <div class="cartDescription">
                                        <h1 class="mb-0 fs-16">
                                            {{prod?.product_info?.name}}
                                        </h1>
                                        <p class="mb-0" *ngIf="prod?.product_info?.brand_name">
                                            {{prod?.product_info?.brand_name}}
                                        </p>
                                        <ng-container *ngIf="prod?.product_info?.attributes?.length > 0">
                                            <div class="pr-costs mb-0" *ngFor="let attr of prod?.product_info?.attributes">
                                                <span *ngIf="attr?.attribute_name && attr?.attribute_name != 'null'">
                                                    <span>{{attr?.attribute_name}} - 
                                                        <span>{{attr?.selected_attr ? attr?.selected_attr  :  attr?.attributesList[0]?.value}}</span>
                                                    </span>
                                                </span>
                                            </div>
                                        </ng-container>
                                        <div class="pr-costs mb-0" *ngIf="prod?.quantity">
                                            <span>Quantity - <span>{{prod?.quantity}}</span></span>
                                        </div>
                                        <div class="pr-costs mb-0" *ngIf="prod?.totalPrice">
                                            <span class="cost">Cost - 
                                                <span>{{prod?.totalPrice | currency :prod?.product_info?.currency_type}} </span>
                                                <span class="fs-10" *ngIf="prod?.product_info?.is_taxable">+ Taxes</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                           
                            <div class="readMoreText text-center pointer" [ngStyle]="{'color':settingsData?.merchandise_button_bg_primary_color}" *ngIf="cartProductsList?.length > 2"
                                (click)="toggleProducts()">SHOW {{!showAllProducts ? "ALL" : "LESS"}}</div>
        
                            <div class="underline mt-15 mb-15"></div>
                            <div class="row fs-15">
                                <div class="col-6">
                                    <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">Order value- </p>
                                </div>
                                <div class="col-6 text-right product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                                    <!-- <img style="height:20px" src="../assets/logo-icon.svg"> -->
                                    <span *ngIf="selectedTransaction == 'crypto'">
                                        <span class="lytText">{{productsTotal | currency:productCurrency}}</span>
                                    </span>
                                    <span
                                        *ngIf="!selectedTransaction || selectedTransaction == 'wallet' || selectedTransaction == 'ott'">{{productsTotal
                                        | currency:productCurrency}}</span>
        
                                </div>
                            </div>
                            <div *ngIf="discountAmount" class="underline mt-2 mb-2"></div>
                            <div class="row fs-15" *ngIf="discountAmount">
                                <div class="col-6">
                                    <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">Base Price- </p>
                                </div>
                                <div class="col-6 text-right product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                                    <!-- <img style="height:20px" src="../assets/logo-icon.svg"> -->
                                    <span *ngIf="selectedTransaction == 'crypto'">
                                        <span class="lytText">{{productsTotal | currency:productCurrency}}</span>
                                    </span>
                                    <span
                                        *ngIf="!selectedTransaction || selectedTransaction == 'wallet' || selectedTransaction == 'ott'">{{productsTotal
                                        | currency:productCurrency}}</span>
        
                                </div>
                            </div>
                            <div class="row fs-15" *ngIf="discountAmount">
                                <div class="col-6">
                                    <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">Product Discounts -</p>
                                </div>
                                <div class="col-6 text-right product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                                    <!-- <img style="height:20px" src="../assets/logo-icon.svg"> -->
                                    <span *ngIf="selectedTransaction == 'crypto'">
                                        <span class="lytText">-{{discountAmount | currency:productCurrency}}</span>
                                    </span>
                                    <span
                                        *ngIf="!selectedTransaction || selectedTransaction == 'wallet' || selectedTransaction == 'ott'">-{{discountAmount
                                        | currency:productCurrency}}</span>
                                </div>
                            </div>
                            <div *ngIf="discountAmount" class="underline mt-2 mb-2"></div>
                            <div class="row fs-15" *ngIf="discountAmount">
                                <div class="col-6">
                                    <p class="product-heading">Sub Total- </p>
                                </div>
                                <div class="col-6 text-right product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                                    <!-- <img style="height:20px" src="../assets/logo-icon.svg"> -->
                                    <span *ngIf="selectedTransaction == 'crypto'">
                                        <span class="lytText">{{productsTotal - discountAmount |
                                            currency:productCurrency}}</span>
                                    </span>
                                    <span
                                        *ngIf="!selectedTransaction || selectedTransaction == 'wallet' || selectedTransaction == 'ott'">{{productsTotal
                                        - discountAmount
                                        | currency:productCurrency}}</span>
        
                                </div>
                            </div>
                            <div class="row fs-15" *ngIf="shippingCost && showShippingForm">
                                <div class="col-6">
                                    <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">Shipping Cost -</p>
                                </div>
                                <div class="col-6 text-right fs-16 product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                                    <span *ngIf="selectedTransaction == 'crypto'">
                                        <span class="lytText">{{shippingCost | currency:productCurrency}}</span>
                                    </span>
                                    <span
                                        *ngIf="!selectedTransaction || selectedTransaction == 'wallet' || selectedTransaction == 'ott'">{{shippingCost
                                        | currency:productCurrency}}</span>
                                </div>
                            </div>
                            <div class="row fs-15" *ngIf="taxAmount">
                                <div class="col-6">
                                    <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">Sales Tax -</p>
                                </div>
                                <div class="col-6 text-right product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                                    <span *ngIf="selectedTransaction == 'crypto'">
                                        <span class="lytText">{{taxAmount | currency:productCurrency}}</span>
                                    </span>
                                    <span
                                        *ngIf="!selectedTransaction || selectedTransaction == 'wallet' || selectedTransaction == 'ott'">{{taxAmount
                                        | currency:productCurrency}}</span>
                                </div>
                            </div>
                            <div class="row fs-15"
                                *ngIf="processingFee && (!selectedTransaction || selectedTransaction =='ott')">
                                <div class="col-6 pr-0">
                                    <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">Processing Fee -</p>
                                </div>
                                <div class="col-6 text-right product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                                    <span *ngIf="selectedTransaction == 'crypto'">
                                        <span class="lytText">{{processingFee | currency:productCurrency}}</span>
                                    </span>
                                    <span
                                        *ngIf="!selectedTransaction || selectedTransaction == 'wallet' || selectedTransaction == 'ott'">{{processingFee
                                        | currency:productCurrency}}</span>
                                </div>
                            </div>
                            <div class="underline mt-2 mb-2"></div>
                            <div class="row fs-16">
                                <div class="col-6 pr-0">
                                    <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">GRAND TOTAL - </p>
                                </div>
                                <div class="col-6 text-right product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                                    <span *ngIf="selectedTransaction == 'crypto'">
        
                                        <span *ngIf="selectedTransaction=='crypto'" matTooltip="{{crypto_amount}}" class="fs-17">(<img src="{{cryptoSymbol}}" width="17px" class="mb-1 mr-1"/>{{sliced_crypto_amount}}...{{cryptoToken}})</span>
                                        <!-- <span class="lytText">({{finalAmount | currency:productCurrency}})</span> -->
                                    </span>
                                    <span class="fs-15">{{selectedTransaction == "ott" || !selectedTransaction ? (finalAmount | currency:productCurrency)
                                        : (finalAmount - processingFee |
                                       currency:productCurrency)}}</span>
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div class="col-6">
                                    <p class="product-heading">Overall Saving -</p>
                                </div>
                                <div class="col-6 text-right">
                                    <span class="lytText">(0.98)</span>
                                </div>
                            </div> -->
        
                        </div>
                    </div>
                    <div class="pl-15 mt-10">Payment </div>
                    <div class="pl-15">
                        <app-payment-transactions [currentBlock]="currentBlock"
                            (getTransactionDetails)="calFee($event)" [settingsData]="settingsData"></app-payment-transactions>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 col-sm-12 col-md-12 col-xs-12" fxShow fxHide.xs = "true">
                <div class="couponBlock text-center p-3" [ngStyle]="{'background-color':settingsData?.merchandise_bg_secondary_color,'color':settingsData?.merchandise_font_secondary_color}">
                    <p class="blockHeading">Avail Coupons & Promotions
                    </p>
                    <input placeholder="Enter Code" class="formInput text-uppercase" [(ngModel)]="couponCode" [ngStyle]="{'background-color':settingsData?.merchandise_bg_secondary_color,'color':settingsData?.merchandise_font_main_color}"
                    (keydown)="preventInvalidSpaces($event)" (input)="onCouponInput($event.target.value)"  (paste)="onCouponPaste($event)">
                    <div class="mt-3">
                        <button mat-flat-button *ngIf="!isDiscountApplied" class="flat-primary-button"
                          [ngStyle]="{'background-color':settingsData?.merchandise_button_bg_primary_color,'color':settingsData?.merchandise_button_font_primary_color}" (click)="verifyCoupon()">Apply</button>
                        <button mat-flat-button class="plain-white-btn" *ngIf="isDiscountApplied" [ngStyle]="{'background-color':settingsData?.merchandise_button_bg_secondary_color,'color':settingsData?.merchandise_button_font_secondary_color}"
                            (click)="clearCode()">Clear</button>
                    </div>
                </div>

                <div class="couponBlock p-3 mt-3" [ngStyle]="{'background-color':settingsData?.merchandise_bg_secondary_color,'color':settingsData?.merchandise_font_secondary_color}">
                    <p class="blockHeading">ORDER SUMMARY</p>
                    <div class="underline mt-2"></div>
                    <div class="order-summary-block">
                        <div class="borderBoxCart mt-3 fs-12" [ngStyle]="{'background-color':settingsData?.merchandise_bg_primary_color,'color':settingsData?.merchandise_font_primary_color}"
                        *ngFor="let prod of cartProductsList.slice(0 , !showAllProducts ? 2 :cartProductsList.length)">
                        <div class="d-flex">
                            <div>
                                <img appHideBrokenImg class="p-img" src="{{prod?.product_img}}">
                            </div>
                            <div class="cartDescription">
                                <h1 class="mb-0 fs-16">
                                    {{prod?.product_info?.name}}
                                </h1>
                                <p class="mb-0" *ngIf="prod?.product_info?.brand_name">
                                    {{prod?.product_info?.brand_name}}
                                </p>
                                <ng-container *ngIf="prod?.product_info?.attributes?.length > 0">
                                    <div class="pr-costs mb-0" *ngFor="let attr of prod?.product_info?.attributes">
                                        <span *ngIf="attr?.attribute_name && attr?.attribute_name != 'null'">
                                            <span>{{attr?.attribute_name ? attr?.attribute_name:''}} - 
                                                <span>{{attr?.selected_attr ? attr?.selected_attr : attr?.attributesList[0]?.value}}</span>
                                            </span>
                                        </span>
                                    </div>
                                </ng-container>
                                <div class="pr-costs mb-0" *ngIf="prod?.quantity">
                                    <span>Quantity - <span>{{prod?.quantity}}</span></span>
                                </div>
                                <div class="pr-costs mb-0" *ngIf="prod?.totalPrice">
                                    <span class="cost">Cost - 
                                        <span>{{prod?.totalPrice | currency :prod?.product_info?.currency_type}}</span>
                                        <span class="fs-10" *ngIf="prod?.product_info?.is_taxable">+ Taxes</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                   
                    <div class="readMoreText text-center pointer" [ngStyle]="{'color':settingsData?.merchandise_button_bg_primary_color}" *ngIf="cartProductsList?.length > 2"
                        (click)="toggleProducts()">SHOW {{!showAllProducts ? "ALL" : "LESS"}}</div>

                    <div class="underline mt-15 mb-15"></div>
                    <div class="row fs-15">
                        <div class="col-6">
                            <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">Order value- </p>
                        </div>
                        <div class="col-6 text-right product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                            <!-- <img style="height:20px" src="../assets/logo-icon.svg"> -->
                            <span *ngIf="selectedTransaction == 'crypto'">
                                <span class="lytText">{{productsTotal | currency:productCurrency}} </span>
                            </span>
                            <span
                                *ngIf="!selectedTransaction || selectedTransaction == 'wallet' || selectedTransaction == 'ott'">{{productsTotal
                                | currency:productCurrency}}</span>

                        </div>
                    </div>
                    <div *ngIf="discountAmount" class="underline mt-2 mb-2"></div>
                    <div class="row fs-15" *ngIf="discountAmount">
                        <div class="col-6">
                            <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">Base Price- </p>
                        </div>
                        <div class="col-6 text-right product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                            <!-- <img style="height:20px" src="../assets/logo-icon.svg"> -->
                            <span *ngIf="selectedTransaction == 'crypto'">
                                <span class="lytText">{{productsTotal | currency:productCurrency}}</span>
                            </span>
                            <span
                                *ngIf="!selectedTransaction || selectedTransaction == 'wallet' || selectedTransaction == 'ott'">{{productsTotal
                                | currency:productCurrency}}</span>

                        </div>
                    </div>
                    <div class="row fs-15" *ngIf="discountAmount">
                        <div class="col-6">
                            <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">Product Discounts -</p>
                        </div>
                        <div class="col-6 text-right product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                            <!-- <img style="height:20px" src="../assets/logo-icon.svg"> -->
                            <span *ngIf="selectedTransaction == 'crypto'">
                                <span class="lytText">-{{discountAmount | currency:productCurrency}}</span>
                            </span>
                            <span
                                *ngIf="!selectedTransaction || selectedTransaction == 'wallet' || selectedTransaction == 'ott'">-{{discountAmount
                                | currency:productCurrency}}</span>
                        </div>
                    </div>
                    <div *ngIf="discountAmount" class="underline mt-2 mb-2"></div>
                    <div class="row fs-15" *ngIf="discountAmount">
                        <div class="col-6">
                            <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">Sub Total- </p>
                        </div>
                        <div class="col-6 text-right product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                            <!-- <img style="height:20px" src="../assets/logo-icon.svg"> -->
                            <span *ngIf="selectedTransaction == 'crypto'">
                                <span class="lytText">{{productsTotal - discountAmount |
                                    currency:productCurrency}}</span>
                            </span>
                            <span
                                *ngIf="!selectedTransaction || selectedTransaction == 'wallet' || selectedTransaction == 'ott'">{{productsTotal
                                - discountAmount
                                | currency:productCurrency}}</span>

                        </div>
                    </div>
                    <div class="row fs-15" *ngIf="shippingCost && showShippingForm">
                        <div class="col-6">
                            <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">Shipping Cost -</p>
                        </div>
                        <div class="col-6 text-right fs-16 product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                            <span *ngIf="selectedTransaction == 'crypto'">
                                <span class="lytText">{{shippingCost | currency:productCurrency}}</span>
                            </span>
                            <span
                                *ngIf="!selectedTransaction || selectedTransaction == 'wallet' || selectedTransaction == 'ott'">{{shippingCost
                                | currency:productCurrency}}</span>
                        </div>
                    </div>
                    <div class="row fs-15" *ngIf="taxAmount">
                        <div class="col-6">
                            <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">Sales Tax -</p>
                        </div>
                        <div class="col-6 text-right product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                            <span *ngIf="selectedTransaction == 'crypto'">
                                <span class="lytText">{{taxAmount | currency:productCurrency}}</span>
                            </span>
                            <span
                                *ngIf="!selectedTransaction || selectedTransaction == 'wallet' || selectedTransaction == 'ott'">{{taxAmount
                                | currency:productCurrency}}</span>
                        </div>
                    </div>
                    <div class="row fs-15"
                        *ngIf="processingFee && (!selectedTransaction || selectedTransaction =='ott')">
                        <div class="col-6">
                            <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">Processing Fee -</p>
                        </div>
                        <div class="col-6 text-right product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                            <span *ngIf="selectedTransaction == 'crypto'">
                                <span class="lytText">{{processingFee | currency:productCurrency}}</span>
                            </span>
                            <span
                                *ngIf="!selectedTransaction || selectedTransaction == 'wallet' || selectedTransaction == 'ott'">{{processingFee
                                | currency:productCurrency}}</span>
                        </div>
                    </div>
                    <div class="underline mt-2 mb-2"></div>
                    <div class="row fs-16">
                        <div class="col-6">
                            <p class="product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">GRAND TOTAL - </p>
                        </div>
                        <div class="col-6 text-right product-heading" [ngStyle]="{'color':settingsData?.merchandise_font_secondary_color}">
                            <span *ngIf="selectedTransaction == 'crypto'">

                                <span *ngIf="selectedTransaction=='crypto'" matTooltip="{{crypto_amount}}" class="fs-17">(<img src="{{cryptoSymbol}}" width="17px" class="mb-1 mr-1"/>{{sliced_crypto_amount}}...{{cryptoToken}})</span>
                                <!-- <span class="lytText">({{finalAmount | currency:productCurrency}})</span> -->
                            </span>
                            <span class="fs-15">{{selectedTransaction == "ott" || !selectedTransaction ? (finalAmount | currency:productCurrency)
                                : (finalAmount - processingFee |
                               currency:productCurrency)}}</span>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-6">
                            <p class="product-heading">Overall Saving -</p>
                        </div>
                        <div class="col-6 text-right">
                            <span class="lytText">(0.98)</span>
                        </div>
                    </div> -->

                </div>
            </div>
        </div>
    </div>
</div>